import { render, staticRenderFns } from "./EditInvoiceComponent.vue?vue&type=template&id=1bc4be9b&scoped=true&"
import script from "./EditInvoiceComponent.vue?vue&type=script&lang=js&"
export * from "./EditInvoiceComponent.vue?vue&type=script&lang=js&"
import style0 from "./EditInvoiceComponent.vue?vue&type=style&index=0&id=1bc4be9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc4be9b",
  null
  
)

export default component.exports